module.exports = __webpack_public_path__ + "img/img3.c786436.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/05/img3.png
// module id = 243
// module chunks = 0